import { useQuery } from "@tanstack/react-query";
import { api } from "../components/api";

export const useDelayAnalysisQuery = (query) => {
  return useQuery({
    queryKey: ["delay-analysis", query],
    queryFn: () => api.customer.getCustomerDelayAnalysis(query),
    keepPreviousData: true,
    select: (data) => {
      return data.data ?? {};
    },
    onSuccess: (data) => {},
    onError: (error) => {
      console.error("Error fetching data:", error);
    },
  });
};

export const useGetAllCustomers = (query) => {
  return useQuery({
    queryKey: ["all-customers", query],
    queryFn: () => api.customer.getAllCustomers(query),
    enabled: !!query,
    keepPreviousData: true,
    select: (data) => {
      return data.data ?? {};
    },
    onSuccess: (data) => {},
    onError: (error) => {
      console.error("Error fetching data:", error);
    },
  });
};
